import React, { useState } from "react";
import { Box, HStack, Text, Image, useMediaQuery, Spacer } from "@chakra-ui/react";
import { IconArrowUpRight } from "@tabler/icons-react";

const Header = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");

  return (
    <Box w={"100%"} h={"7vh"} bg={"white"} display="flex" alignItems="center" px={5}>
      {/* Image on the left */}
      <Image src="/4sqrN.png" alt="4sqr" boxSize="40px" objectFit="contain" />
      {!isLargerThan900 && (
        <Text
          fontSize="10px"
          fontWeight="bold"
          ps={2}
          color="black"
          fontFamily="Tinos, Times, serif"
        >
          Foursquare Gospel <br />
          Church Haruna
        </Text>
      )}

      {/* Centered text */}
      {isLargerThan900 && (
        <HStack w="100%" justify="center">
          <Text fontSize="lg" fontWeight="bold" color="black" fontFamily="Tinos, Times, serif" ms={'100px'}>
            Foursquare Gospel Church Haruna
          </Text>
        </HStack>
          )}
          <Spacer/>

      {/* Button on the right */}
      <a
        href="https://maps.app.goo.gl/wLhjg6WemDb8fDdU9"
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        <Box
          bg="Black"
          color="white"
          borderRadius="full"
          size="sm"
          px={5}
          py={1}
          // ml={5}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        //   position="relative"
            right={0}
        >
          <HStack spacing={3}>
            <Text transition="opacity 0.3s ease-in-out" whiteSpace="nowrap">
              <Text fontSize={["xs", "sm"]}>Find your way to church</Text>
            </Text>
            <IconArrowUpRight transition="opacity 0.3s ease-in-out" />
          </HStack>
        </Box>
      </a>
    </Box>
  );
};

export default Header;
